import { combineReducers } from 'redux';
import getStudent from './getStudent';
import getParent from './getParent';
import getPayment from './getPayment';
import getLocationCoordinator from './getLocationCoordinator';
import getUser from './getUser';
import getAdmin from './getAdmin';
import getEmail from './getEmail';
import getRole from './getRole';
import getRegion from './getRegion';
import getTeacherView from './getTeacherView';
import getLocations from './getLocations';
import getCourseManager from './getCourseManager';
import academicPanel from './getAcademicPanel';
import homeworkSchema from './getHomeworkSchema';
import getExamCenterManager from './getExamCenterManager';
import getGrade from './getGrades';
import getQuizSchema from './getQuizSchema';
import curricularActivitiesSchema from './getCurricularActivities';
import assignmentsSchema from './getAssignmentsSchema';

const rootReducer = combineReducers({
  getGrade,
  getStudent,
  getParent,
  getPayment,
  getLocationCoordinator,
  getUser,
  getAdmin,
  getEmail,
  getRole,
  getRegion,
  getTeacherView,
  getCourseManager,
  getLocations,
  academicPanel,
  homeworkSchema,
  getExamCenterManager,
  getQuizSchema,
  curricularActivitiesSchema,
  assignmentsSchema,
});

export default rootReducer;
